module.exports = __webpack_public_path__ + "img/darik.c5913804.svg";